import React from 'react';
import RolesAndPermissionsComponent from './roles-and-permissions.component';

function RolesAndPermissions() {
    return <RolesAndPermissionsComponent />;
}

export default RolesAndPermissions;
